import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface ChatInputProps {
  onFocusInput?: () => void;
}

const ChatInput: React.FC<ChatInputProps> = ({ onFocusInput }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleInputClick = () => {
    if (onFocusInput) {
      onFocusInput();
    } else {
      navigate("/chat");
    }
  };

  return (
    <div className="bg-grey rounded-xl">
      <form>
        <div
          className="relative flex items-start justify-between overflow-hidden p-[2px] rounded-xl"
          style={{
            background: "linear-gradient(97deg, #3AF062 0%, #231ADD 100%)",
            borderRadius: "12px",
          }}>
          <textarea
            placeholder="✨ Would you like to ask?"
            className="text-sm font-light w-full rounded-xl bg-black outline-none cursor-pointer resize-none"
            style={{
              paddingLeft: "16px",
              paddingTop: "16px",
              paddingBottom: "40px",
              height: isMobile ? "70px" : isTablet ? "80px" : "92px",
              borderRadius: "12px",
            }}
            onClick={handleInputClick}
            onFocus={handleInputClick}
          />

          <div>
            <button
              type="button"
              className={`absolute left-3 bottom-3 rounded-xl p-1`}
              onClick={handleInputClick}>
              <img
                src="/assets/images/icon-add.svg"
                alt="add"
                className={`${isMobile ? "w-5 h-5" : "w-6 h-6"}`}
              />
            </button>

            <button
              type="submit"
              className="absolute right-3 bottom-3"
              onClick={(e) => {
                e.preventDefault();
                handleInputClick();
              }}>
              <img
                src="/assets/images/icon-arrow-up.svg"
                alt="send-message"
                className={`${isMobile ? "w-6 h-6" : "w-8 h-8"}`}
              />
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ChatInput;
